export const SCROLL_BAR_DEFAULT_SIZE = 12;
